export enum HorseCouponListenerEvent {
    UPDATE = "UPDATE",
    REMOVE = "REMOVE",
}

export enum HorseCouponPushEvent {
    UPDATE = "UPDATE",
    REMOVE = "REMOVE",
}

export enum HarryStakeType {
    FIXED = "FIXED",
    CUSTOM = "CUSTOM",
}

export enum HarryActiveStep {
    FLAVOR = "FLAVOR",
    STAKE = "STAKE",
}
